import { render, staticRenderFns } from "./ReadOnlyTable.vue?vue&type=template&id=1a5990d5&scoped=true"
import script from "./ReadOnlyTable.vue?vue&type=script&lang=js"
export * from "./ReadOnlyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5990d5",
  null
  
)

export default component.exports